import { cn } from '@/lib/utils';

type Props = {
  color?: 'dark' | 'disabled' | 'black' | 'light' | 'baseBlue';
  offset?: number;
  style?: React.CSSProperties;
  mb?: '8';
  className?: string;
};

const colorMap: Record<NonNullable<Props['color']>, string> = {
  light: 'border-border',
  dark: 'border-gray-400',
  disabled: 'border-muted-foreground/50',
  black: 'border-black',
  baseBlue: 'border-blue-scale-700',
};

export const Divider = ({ color = 'light', mb, style, className }: Props) => {
  return (
    <div
      className={cn(
        'w-full border-t border-b-0 border-l-0 border-r-0 m-0 border-[1px]',
        colorMap[color],
        mb === '8' && 'mb-2',
        className,
      )}
      style={style}
    />
  );
};
